module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Abstract"
    }
  }, [_c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('ul', [_c('li', {
    staticClass: "left"
  }, [_vm._v("\n          Presenting Type\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "right"
  }, _vm._l((_vm.radiotype), function(item, index) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form),
        expression: "form"
      }],
      staticClass: "magic-radio",
      attrs: {
        "type": "radio",
        "name": "radio",
        "id": index
      },
      domProps: {
        "value": item,
        "checked": _vm._q(_vm.form, item)
      },
      on: {
        "change": function($event) {
          _vm.form = item
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": index
      }
    }, [_vm._v(_vm._s(item))])])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mid"
    }
  }, [_c('Form', {
    ref: "formValidate",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 165
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Topic",
      "prop": "Topic"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate.Topic),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "Topic", $$v)
      },
      expression: "formValidate.Topic"
    }
  }, _vm._l((_vm.selecttype), function(item, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Title",
      "prop": "Title"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate.Title),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "Title", $$v)
      },
      expression: "formValidate.Title"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Key Words",
      "prop": "keyword"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate.keyword),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "keyword", $$v)
      },
      expression: "formValidate.keyword"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Content",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate.content),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "content", $$v)
      },
      expression: "formValidate.content"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('div', {
    attrs: {
      "id": "file"
    }
  }, [_c('div', {
    staticClass: "list1"
  }, [_c('span', [_vm._v("Upload files")]), _c('p', [_vm._v("Choose file"), _c('input', {
    attrs: {
      "id": "fileipt",
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.changeFile()
      }
    }
  })]), _c('p', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addupdatepaper('formValidate')
      }
    }
  }, [_vm._v("Click to upload")]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.filename.fileUrl
    }
  }, [_vm._v("file name:" + _vm._s(_vm.filename.fileOrig))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "100px",
      "padding-top": "20px",
      "overflow": "hidden"
    }
  }, _vm._l((_vm.imgfile), function(item, index) {
    return _c('p', {
      key: index,
      staticStyle: {
        "display": "block",
        "width": "100%"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url
      }
    }, [_vm._v(_vm._s(item.name))])])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btm"
    },
    on: {
      "click": function($event) {
        _vm.next('formValidate')
      }
    }
  }, [_vm._v("Save and Next")])])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c2951f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paper/Abstract.vue
// module id = 783
// module chunks = 10